module.exports = __webpack_public_path__ + "img/login.3f033b6e.png";